import { getIsLocalDev } from "@pathwright/utils/src/env/env"
import { SignJWT } from "jose"

let __devModeToken: string | null = null

// Only set dev mode token in development environment.
if (getIsLocalDev()) {
  __devModeToken = "RcItjdWU81LMlStyjOx53wSVYm53bXHL"
}

export function getDevModeToken() {
  return __devModeToken
}

let __devModeJWT: string | null = null

// Generate a JWT token for dev mode authentication.
// Singleton pattern to avoid regenerating token multiple times.
export async function getDevModeJWT() {
  if (!__devModeToken) {
    return null
  }

  if (__devModeJWT) {
    return __devModeJWT
  }

  const secret = new TextEncoder().encode(__devModeToken)
  // Create a simple JWT token with the dev mode token as the payload.
  const token = (__devModeJWT = await new SignJWT()
    .setProtectedHeader({ alg: "HS256" })
    .setIssuedAt()
    .sign(secret!))

  return token
}

// Synchronous version of getDevModeJWT for use in non-async contexts.
export function getDevModeJWTSync() {
  return __devModeJWT
}

// Initialize the dev mode JWT immediately for later use.
// This way, we don't have to await it later (like in in the getSwitchSpaceLink)
getDevModeJWT()
